var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('app-header',{key:_vm.headerIndex,attrs:{"fixed":_vm.fixedHeader},on:{"updateCountry":function($event){return _vm.updateCountry($event)}}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"country":_vm.country}}),(_vm.isFooter)?_c('app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }